import { render } from "./VtcInitiale.vue?vue&type=template&id=bea19fee"
import script from "./VtcInitiale.vue?vue&type=script&lang=js"
export * from "./VtcInitiale.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__